// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ac4b0186","239":"581d9a57","667":"0ec32f17"}[chunkId] + ".chunk.js";
};